import { Children, cloneElement, isValidElement, ReactElement } from 'react';

import withKey from './with-key';

function propagateProps(children: ReactElement | ReactElement[], properties: {}, generateKey = false): ReactElement[] {
  return Children.toArray(children)
    .filter((child) => isValidElement(child))
    .map((child) => {
      const props = generateKey ? withKey(properties) : properties;
      return cloneElement(child, props);
    });
}

export default propagateProps;
